export default __webpack_public_path__ + "static/media/idleLandMark.1febfa6e.jpg";